export default "__VITE_IMAGE_ASSET__7ff8de8a__";